<template>
  <div class="specifications">
    <div class="title">
      Product Specifications
    </div>
    <div class="list">
      <div
        v-for="(item, index) in showMore ? formatArrary : formatArrary.slice(0, 10)"
        :key="index"
        class="list-item"
      >
        <div class="list-item-left">
          {{ item.attributeNameTrans }}
        </div>
        <div class="list-item-right">
          {{ item.valueTrans }}
        </div>
      </div>
    </div>
    <div
      v-if="!showMore && formatArrary.length > 10"
      @click="showMore = true"
      class="more"
    >
      <span class="text">More attributes</span>
      <Icon name="arrow-down-l-2" />
    </div>
  </div>
</template>

<script setup>
import Icon from '@/components/Icon/Icon.vue'
import { ref } from 'vue'

const props = defineProps({
  list: {
    type: Array,
    default: () => []
  }
})

const showMore = ref(false)

const formatArrary = ref([])

const mergeAttributes = (arr) => {
  const result = {}

  // 遍历输入数组
  arr.forEach((item) => {
    const {
      attributeId,
      attributeName,
      attributeNameTrans,
      value,
      valueTrans
    } = item

    if (!result[attributeId]) {
      // 如果 attributeId 不在 result 对象中，初始化
      result[attributeId] = {
        attributeId,
        attributeName,
        attributeNameTrans,
        value,
        valueTrans
      }
    } else {
      // 如果 attributeId 已存在，拼接 valueTrans
      result[attributeId].valueTrans += `, ${valueTrans}`
    }
  })

  // 将结果对象转换为数组
  return Object.values(result)
}

onMounted(() => {
  formatArrary.value = mergeAttributes(props.list)
})

</script>

<style lang='less' scoped>
.specifications {
  margin-bottom: 32px;
  .title {
    color: #232323;
    font-size: 18px;
    font-family: mon-700;
    margin-bottom: 20px;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    .list-item {
      display: flex;
      width: 50%;
      border: 1px solid #dfdfdf;
      margin-right: -1px;
      margin-bottom: -1px;

      .list-item-left {
        display: flex;
        align-items: center;
        text-align: -webkit-auto;
        width: 152px;
        min-height: 54px;
        background-color: #f8f8f8;
        color: #232323;
        font-size: 11px;
        padding-left: 16px;
        padding-right: 16px;
        font-family: mon-600;
      }
      .list-item-right {
        flex: 1;
        display: flex;
        align-items: center;
        padding: 13px 16px 13px 16px;
        color: #6E717A;
        font-size: 11px;
        font-family: mon-500;
      }
    }
  }
  .more {
    display: flex;
    align-items: center;
    gap: 2px;
    height: 48px;
    padding: 0 16px;
    .text {
      color: #232323;
      font-size: 11px;
      font-family: mon-600;
      text-decoration: underline;
      cursor: pointer;
      &:hover {
        color: var(--link-hover-color);
      }
    }
  }
}
</style>
